import { Link } from "react-router-dom";
import { EmptyState } from "../components/StatusViews.js";

export function NotFoundPage() {
  return (
    <EmptyState icon="search">
      ページが見つかりませんでした。
      <br />
      <Link to="/">トップへ戻る</Link>
    </EmptyState>
  );
}
